<ng-template #filterMenu let-mobile="mobile" let-filters="filters">
  <div [id]="'filterIcon' + (mobile ? 'Mobile' : '')" class="extra-filters">
    <button *ngIf="!!version && selectedTab === PROGRAM && !deviceTimezoneEqualsAllProgramTimezones && !excludedFieldIds.includes('viewMyTimezoneToggle')"

      mat-button (click)="viewMyTimezoneToggle()">
    {{ viewMyTimezone ? 'Hide' : 'View'}} my timezone</button>
    <icon *ngIf="selectedTab === PROGRAM" [icon]="'grow'" (click)="expandAll()"></icon>
    <icon *ngIf="selectedTab === PROGRAM" [icon]="'shrink'" (click)="collapseAll()"></icon>
    <icon-text *ngIf="filters"
      [active]="selectedTab === PROGRAM ? !!extraFiltersIds.size : !!extraExhibitorsFiltersIds.size" 
      [text]="'Filter'" 
      (click)="openExtraFilters(!!mobile, selectedTab === PROGRAM ? 'program' : 'exhibitor')"
    ></icon-text>
  </div>
</ng-template>

<branding-wrapper [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'"
  [isConfigure]="isConfigure"
  [isApp]="isApp"
  (change)="change.emit($event)"
>
  <shared-timeline-wrapper
    *ngIf="{ hasTabs: tabsMenu.length > 1 && (joiEvent && !loading),
      hasFilters: (selectedTab === PROGRAM && labelGroups) || (selectedTab === EXHIBITORS && exhibitorLabelGroups && !excludedFieldIds.includes('exhibitorProfileLabels'))} as vars"
    [eventTitle]="joiEvent?.event_title"
    [title]="title"
    [description]="joiEvent?.description"
    [venue]="venue"
    [loading]="loading"
    [madeWithJoi]="madeWithJoi && selectedTab !== HOME"
    [hideTop]="selectedTab === HOME"
    [unavailable]="!joiEvent && !loading"
  >
    <calls-to-action *ngIf="selectedTab !== HOME && !!CTALinks?.length && (
      (selectedTab === PROGRAM && !excludedFieldIds.includes('programCTAs')) ||
      (selectedTab === PERFORMERS && !excludedFieldIds.includes('performerCTAs')) ||
      (selectedTab === SPONSORS && !excludedFieldIds.includes('sponsorCTAs')) ||
      (selectedTab === EXHIBITORS && !excludedFieldIds.includes('exhibitorCTAs'))
      )" [ctas]="CTALinks"></calls-to-action>
    <ng-container *ngIf="vars.hasTabs || selectedTab === PROGRAM" >
      <joi-nav-wrapper
        *ngIf="!isApp"
        class="desktop"
        [ngClass]="{ noLine: !vars.hasTabs && vars.hasFilters }"
        [hideTabs]="!vars.hasTabs"
        [menuItems]="tabsMenu"
        [menuMap]="tabNames"
        [publicStyle]="true"
        [defaultMenuMap]="defaultTabNames"
        [selectedId]="selectedTab" 
        (selectItem)="selectTab($event)"
      >
        <ng-container [ngTemplateOutlet]="filterMenu" [ngTemplateOutletContext]="{ mobile: false, filters: vars.hasFilters }"></ng-container>
      </joi-nav-wrapper>
      <div class="joi-nav-wrapper-mobile mobile" *ngIf="!isApp">
        <div class="view-dropdown-area" *ngIf="vars.hasTabs">
          <div class="view">
          View:
          </div>
          <mat-select [(value)]="selectedTab" >
            <mat-option *ngFor="let item of tabsMenu" [value]="item" >{{ tabNames[item] }}</mat-option>
          </mat-select>
        </div>
        <ng-container [ngTemplateOutlet]="filterMenu" [ngTemplateOutletContext]="{ mobile: true, filters: vars.hasFilters }"></ng-container>
      </div>
      <div class="app-menu" *ngIf="!!isApp">
        <app-icon *ngFor="let tab of tabsMenu" [icon]="tabIcons[tab]" [title]="tabNames[tab]" [active]="selectedTab === tab" (click)="selectTab(tab)"></app-icon>
      </div>
    </ng-container>
    <home-page *ngIf="!isConfigure && selectedTab === HOME && joiEvent" 
      [brandingData]="brandingData" 
      [homePageData]="homePageData" 
      [performers]="joiEvent.performers"
      [sponsors]="joiEvent.sponsors"
      [exhibitors]="joiEvent.exhibitors"
      [callsToAction]="excludedFieldIds.includes('homeCTAs') ? null : CTALinks"
      [isApp]="isApp"
      [tabNames]="tabNames"
    ></home-page>
    <ng-content *ngIf="!!isConfigure && selectedTab === HOME" select=".configure-home"></ng-content>
    <performer-gallery 
      *ngIf="selectedTab === PERFORMERS" 
      [joiEvent]="joiEvent"
      [timeline]="data"
      [programTexts]="programTexts"
      [isPreview]="isPreview || isConfigure"
      [entityName]="tabNames['performersTab'] || defaultTabNames['performersTab']"
      [hidePhotos]="!!excludedFieldIds?.includes('performerProfilePhotoUrl')"
      [hideSessions]="!!excludedFieldIds?.includes('includePerformerSessions')"
      (scrollUp)="scrollUp()"
    ></performer-gallery>
    <sponsor-gallery 
      *ngIf="selectedTab === SPONSORS" 
      [joiEvent]="joiEvent"
      [timeline]="data"
      [isPreview]="isPreview || isConfigure"
      [entityName]="tabNames['sponsorsTab'] || defaultTabNames['sponsorsTab']"
      [hideTypes]="!!excludedFieldIds?.includes('sponsorProfileType')"
      [hideSessions]="!!excludedFieldIds?.includes('includeSponsorSessions')"
      [programTexts]="programTexts"
      (scrollUp)="scrollUp()"
    ></sponsor-gallery>
    <exhibitor-gallery 
      *ngIf="selectedTab === EXHIBITORS" 
      [joiEvent]="joiEvent"
      [isPreview]="isPreview || isConfigure"
      [entityName]="tabNames['exhibitorsTab'] || defaultTabNames['exhibitorsTab']"
      [selectedLabelIds]="!excludedFieldIds.includes('exhibitorProfileLabels') ? extraExhibitorsFiltersIds : null"
      (scrollUp)="scrollUp()"
    ></exhibitor-gallery>
    <publish-timeline-view *ngIf="selectedTab === PROGRAM && timeline"
      [timeline]="timeline"
      [breakDays]="excludedFieldIds?.includes('breakDays')"
      [programTexts]="programTexts"
      [excludedFieldIds]="excludedFieldIds"
      [joiEvent]="joiEvent"
      [$toggleAll]="$toggleAll"
      [userSelectedTimezone]="userSelectedTimezone"
      [sponsorsCustomTitle]="tabNames['sponsorsTab'] || undefined"
    ></publish-timeline-view>
  </shared-timeline-wrapper>
</branding-wrapper>